import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CashstarLinksCustom from './CashstarLinksCustom';
import CashstarLinksDefault from './CashstarLinksDefault';
import Logos from './Logos';
import LanguagePicker from '../intl/LanguagePicker';
import { getCustomCashstarLinks, getCardholderAgreementText } from './footerSelectors';
import FooterCardholderAgreement from './FooterCardholderAgreement';
import { getCardholderAgreementEnabled } from '../brand/brandSelectors';


export const Footer = ({
    customLinks,
    cardholderText,
    isCardholderAgreementEnabled
}) => (
    <footer className="footer">
        <div className="footer-container">
            <div className="footer-language">
                <LanguagePicker openUpwards />
            </div>
            <div className="footer-row">
                <div className="footer-links">
                    <nav className="footer-links__nav">
                        { customLinks.size
                            ? <CashstarLinksCustom customLinks={customLinks} />
                            : <CashstarLinksDefault /> }
                    </nav>
                </div>
            </div>
            <div className="footer-row">
                <Logos />
            </div>
            { cardholderText && isCardholderAgreementEnabled
                && (
                    <FooterCardholderAgreement cardholderText={cardholderText} />
                )
            }
        </div>
    </footer>
);

Footer.defaultProps = {
    cardholderText: null,
    isCardholderAgreementEnabled: false

};

Footer.propTypes = {
    customLinks: ImmutablePropTypes.list.isRequired,
    cardholderText: PropTypes.string,
    isCardholderAgreementEnabled: PropTypes.bool
};


export const mapStateToProps = state => ({
    customLinks: getCustomCashstarLinks(state),
    cardholderText: getCardholderAgreementText(state),
    isCardholderAgreementEnabled: getCardholderAgreementEnabled(state)
});

export default connect(mapStateToProps)(Footer);
